import { createRouter, createWebHashHistory } from 'vue-router';
import AuthorEditorWrapper from './components/AuthorEditorWrapper.vue';
import AuthorHistoryWrapper from './components/AuthorHistoryWrapper.vue';
import AuthorHome from './components/AuthorHome.vue';
import AuthorPreviewWrapper from './components/AuthorPreviewWrapper.vue';
import AuthorTranslateWrapper from './components/AuthorTranslateWrapper.vue';
import AuthorAudioWrapper from './components/AuthorAudioWrapper.vue';
import AuthorAudioJIT from './components/AuthorAudioJIT.vue';
import AuthorAudioJITWrapper from './components/AuthorAudioJITWrapper.vue';
import AuthorAudioJitLexicons from './components/AuthorAudioJitLexicons.vue';
import AuthorTranscriptWrapper from './components/AuthorTranscriptWrapper.vue';
import AuthorPublishBespokeWrapper from './components/AuthorPublishBespokeWrapper.vue';
import CourseMetadataEditorWrapper from './components/CourseMetadataEditorWrapper.vue';
import ResourceMetadataEditorWrapper from './components/ResourceMetadataEditorWrapper.vue';
import BulkAudio from './components/BulkAudio.vue';
import BulkCustomisations from './components/BulkCustomisations.vue';
import BulkTranslationJobsList from './components/BulkTranslationJobsList.vue';
// import Login from './components/Login.vue';

const routes = [
  { path: '/editor/:fileName', component: AuthorEditorWrapper },
  { path: '/history/:fileName', component: AuthorHistoryWrapper },
  { path: '/preview/:fileName', component: AuthorPreviewWrapper },
  { path: '/home', component: AuthorHome },
  { path: '/translate/:fileName', component: AuthorTranslateWrapper },
  { path: '/audio/:fileName', component: AuthorAudioWrapper },
  { path: '/audio-jit', component: AuthorAudioJIT },
  { path: '/audio-jit/:fileName', component: AuthorAudioJITWrapper },
  { path: '/audio-jit-lexicons', component: AuthorAudioJitLexicons },
  { path: '/transcript/:fileName', component: AuthorTranscriptWrapper },
  { path: '/publish/:fileName', component: AuthorPublishBespokeWrapper },
  {
    path: '/metadata-editor/:fileName',
    component: CourseMetadataEditorWrapper
  },
  {
    path: '/resource-metadata/:fileName',
    component: ResourceMetadataEditorWrapper
  },
  { path: '/bulk-audio', component: BulkAudio },
  { path: '/bulk-customisations', component: BulkCustomisations },
  { path: '/bulk-translation-jobs', component: BulkTranslationJobsList },
  { path: '/:pathMatch(.*)*', redirect: `/home` }
];

export const routerHistory = createWebHashHistory();

export const router = createRouter({ history: routerHistory, routes });
